<script>
    export let experimentsSize = 0
    export let sortOrder = ""

    import firebase from "firebase/app"
    import "firebase/firestore"

    let experiments = []

    let unsubscribe
    $: {
        if (unsubscribe) {
            unsubscribe()
        }
        unsubscribe = firebase.firestore()
            .collection("Experiments")
            .orderBy(sortOrder || "startTime", sortOrder == "name" ? "asc" : "desc")
            .limit(200)
            .onSnapshot(querySnapshot => {
                experimentsSize = querySnapshot.size
                const downloadedExperiments = querySnapshot.docs.map((experiment) => ({...experiment.data(), id: experiment.id}))
                if (!sortOrder) {
                    downloadedExperiments.sort((a, b) => {
                        const isActiveA = a.state === 'active'
                        const isActiveB = b.state === 'active'
                        const startTimestampA = a.startTime ? a.startTime.toDate().getTime() : 0
                        const startTimestampB = b.startTime ? b.startTime.toDate().getTime() : 0
                        if (!isActiveA && isActiveB) return 1
                        else if (isActiveA && !isActiveB) return -1
                        else if (isActiveA && isActiveB) {
                            if (startTimestampA < startTimestampB) return 1
                            if (startTimestampA > startTimestampB) return -1
                        }
                        return 0
                    })
                }
                experiments = downloadedExperiments
            }, err => {
                console.log(`Encountered error: ${err}`)
            });
    }

	function getExperimentClass(experiment) {
        const now = new Date()
        now.setUTCHours(23, 59, 0, 0)

		if (experiment.state == "active" && experiment.exposure > 0 && experiment.startTime < firebase.firestore.Timestamp.fromDate(now))
            return "active"
        else if (experiment.state == "disabled")
            return "disabled"
    	return "unknown"
	}    
</script>


<div>
    <table class="experiment-table">
        <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Description</th>
                <th>Exposure</th>
                <th>Start time</th>
                <th>End time</th>
                <th>Users</th>
            </tr>
        </thead>
        <tbody>
            {#each experiments as experiment}
                <tr on:click={(e) => window.location.href = "/#/Experiment/" + experiment.id} class="{getExperimentClass(experiment)}">
                    <td class="experiment-id">{experiment.id}</td>
                    <td class="experiment-name">{experiment.name}</td>
                    <td class="experiment-description">{experiment.description}</td>
                    <td class="experiment-exposure">{100 * experiment.exposure}%</td>
                    <td class="experiment-start-time">{experiment.startTime ? experiment.startTime.toDate().toLocaleDateString() : " - "}</td>
                    <td class="experiment-end-time">{experiment.endTime ? experiment.endTime.toDate().toLocaleDateString() : " - "}</td>
                    <td class="experiment-users">{experiment.users}
                        {#if experiment.dailyUsers}
                            <div class="experiment-daily-users">+{experiment.dailyUsers}</div>
                        {/if}
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>


<style>
    .active {
        background-color: #E2EFFF;
    }
    .disabled {
        background-color: #F5F5F5;
    }
    .unknown {
        background-color: #FFFFFF;
    }

    .experiment-table {
        width: 110%;
    }
    /*
    .experiment-id {
        width: 5%;
    }
    .experiment-name {
        width: 15%;
    }
    .experiment-description {
        width: 35%;
    }
    */
    .experiment-active-days {
        width: 15%;
        font-size: small;
    }
    .experiment-start-time {
        width: 10%;
        font-style: italic;
        color: grey;
    }
    .experiment-end-time {
        width: 10%;
        font-style: italic;
        color: grey;
    }
    /*.experiment-users {
        width: 10%;
    }*/
    .experiment-daily-users {
        color: green;
        font-size: small;
    }
</style>